var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mgm-product-item"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.image
    }
  })]), _c('div', {
    staticClass: "right-content"
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('div', {
    staticClass: "second-title"
  }, [_vm._v(_vm._s(_vm.product.secondTitle))])]), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "volume"
  }, [_vm._v(" X"), _c('b', [_vm._v(_vm._s(_vm.product.volume))])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }